import jsPDF from 'jspdf';
import axiosInstance from '../../../../axiosInstance';

// Function to fetch shop details (you can customize this to fit your needs)
const fetchShopDetails = async () => {
    try {
        const response = await axiosInstance.get('/shop-details');


        if (response.status == 200) {
            console.log(response);
            return response.data.shop;
        } else {
            throw new Error('Error fetching shop details');
        }
    } catch (error) {
        console.log('Error:', error);
        return null;
    }
};

const generateReceipt = async (saleDetails, items, totalQuantity, totalPrice, totalDiscount) => {
    const shop = await fetchShopDetails();
    if (!shop) {
        console.error('Shop details could not be fetched');
        return;
    }
    
    const doc = new jsPDF();

    // Fonts and colors
    doc.setFont("helvetica", "normal");
    doc.setFontSize(14);

    // Header
    doc.setFont("helvetica", "bold");
    doc.text(shop.name, 105, 10, { align: 'center' }); // Shop name
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text(`Phone: ${shop.phone || 'N/A'}`, 105, 15, { align: 'center' });
    doc.line(10, 20, 200, 20); // Separator line

    // Title
    doc.setFontSize(12);
    doc.setFont("helvetica", "bold");
    doc.text(`${saleDetails?.type === 'invoice' ? 'Invoice' : 'Receipt'}`, 105, 30, { align: 'center' });

    // Sale Details
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");

    let yPosition = 40; // Initialize yPosition before it's used

    doc.text(`${saleDetails?.type === 'invoice' ? 'Invoice' : 'Receipt'} No: ${saleDetails?.invoice_number || saleDetails?.receipt_number}`, 10, yPosition);
    yPosition += 5;

    doc.text(`Customer Name: ${saleDetails?.customer?.name || ''}`, 10, yPosition);
    yPosition += 5;

    // Add "Account" line only if `saleDetails?.type === 'receipt'`
    if (saleDetails?.type === 'receipt') {
        doc.text(`Account: ${saleDetails?.account?.account_name || ''}`, 10, yPosition);
        yPosition += 5;
    }

    // Add "Due Date" or "Payment Date" line
    doc.text(
        `${saleDetails?.type === 'invoice' ? 'Due Date:' : 'Payment Date:'} ${saleDetails?.type === 'invoice' ? saleDetails?.due_date : saleDetails?.payment_date || 'N/A'}`, 
        10, 
        yPosition
    );

    // Table Headers
    yPosition += 10;
    doc.setFont("helvetica", "bold");
    doc.text('Product', 10, yPosition);
    doc.text('Qty', 80, yPosition, { align: 'right' });
    doc.text('Price', 100, yPosition, { align: 'right' });
    doc.text('Discount', 140, yPosition, { align: 'right' });
    doc.text('Total', 170, yPosition, { align: 'right' });
    doc.line(10, yPosition + 2, 200, yPosition + 2); // Table header separator line

    // Table Content
    yPosition += 5;
    doc.setFont("helvetica", "#272728FF");
    items.forEach(({ product, quantity, price,discount }, index) => {
        const validPrice = Number(price) || 0; // Ensure price is a number
        const validdiscount = Number(discount) || 0;
        const total = ((quantity * validPrice) - validdiscount).toFixed(2);

        doc.text(`${index + 1}. ${product?.name || 'N/A'}`, 10, yPosition); // Product Name
        doc.text(quantity.toString(), 80, yPosition, { align: 'right' }); // Quantity
        doc.text(validPrice.toFixed(2), 100, yPosition, { align: 'right' }); // Price
        doc.text(validdiscount.toFixed(2), 140, yPosition, { align: 'right' });
        doc.text(total, 170, yPosition, { align: 'right' }); // Total
        yPosition += 5;

        // Add page if content exceeds limit
        if (yPosition > 270) {
            doc.addPage();
            yPosition = 10; // Reset position for the new page
        }
    });

    // Summary Section
    yPosition += 5;
    doc.line(10, yPosition, 200, yPosition); // Summary separator line
    yPosition += 5;

    const formattedTotalPrice = Number(totalPrice) || 0; // Ensure totalPrice is a valid number
    const formattedTotalDiscount = Number(totalDiscount) || 0;
    doc.setFont("helvetica", "bold");
    doc.text(`Total Quantity: ${totalQuantity}`, 10, yPosition,);
    doc.text(`Total Price: ${formattedTotalPrice.toFixed(2)}`, 140, yPosition, { align: 'right' });
    doc.text(`Total Discount: ${formattedTotalDiscount.toFixed(2)}`, 200, yPosition, { align: 'right' });

    // Footer
    yPosition += 10;
    doc.setFont("helvetica", "italic");
    doc.text('Thank you for shopping with us!', 105, yPosition, { align: 'center' });
    doc.setFontSize(8);
    doc.text('Visit us again!', 105, yPosition + 5, { align: 'center' });

    // Save the PDF
    const receiptNumber = saleDetails?.invoice_number || saleDetails?.receipt_number || 'Unknown';
    doc.save(`${saleDetails?.type === 'invoice' ? `Invoice_${receiptNumber}.pdf` : `Receipt_${receiptNumber}.pdf`}`);
};

export default generateReceipt;

